import { DeleteOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Form, FormInstance, Typography } from 'antd'
import { DefaultOptionType } from 'antd/es/select'

import { CUATMClassifierElementDto } from 'src/api/requests'
import { CUATMInfiniteSelect } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const MonitoringInstitutionsCard = ({ form }: Props) => {
  const { t, currentLang } = useLocales()

  const onDelete = (id?: string) => {
    const localities = form.getFieldValue('monitoringLocalities')

    form.setFieldValue(
      'monitoringLocalities',
      localities.filter(
        (locality: CUATMClassifierElementDto) => locality.id !== id
      )
    )
  }

  const onAdd = (value: DefaultOptionType) => {
    const localities = form.getFieldValue('monitoringLocalities') || []
    if (
      !localities.some((l: CUATMClassifierElementDto) => l.id === value.value)
    ) {
      form.setFieldValue('monitoringLocalities', [
        ...localities,
        {
          id: value.value,
          translation: {
            [currentLang.value]: value.label
          }
        }
      ])
    }
  }

  return (
    <Card title={t('organizational_structure.monitoring_institutions_card')}>
      <Form.Item shouldUpdate>
        {() => {
          const localities = form.getFieldValue('monitoringLocalities') || []

          return (
            <Flex vertical gap={16}>
              {localities.map((locality: CUATMClassifierElementDto) => (
                <Flex key={locality.id} justify="space-between">
                  <Typography.Text>
                    {locality.translation?.[currentLang.value]}
                  </Typography.Text>
                  <Button
                    icon={<DeleteOutlined />}
                    danger
                    size="small"
                    onClick={() => onDelete(locality.id)}
                  />
                </Flex>
              ))}
              <CUATMInfiniteSelect
                value={null}
                onSelect={(_, value) => onAdd(value)}
                placeholder={t('organizational_structure.add_locality')}
              />
            </Flex>
          )
        }}
      </Form.Item>
    </Card>
  )
}
